import { FrequentPassageStickerType } from '@legacy-types';

import { api } from '@shared/api/api';

export const getFrequentPassageStickerTypes = api.createIndex<FrequentPassageStickerType>(
  'frequent-passage-sticker-types'
);
